import { createStore } from 'idb-keyval';

const imageStore = createStore('MRAT_IMAGE_DB', 'ImageList');

export default imageStore;
